import { canGetRiskLayoutPages } from "@/route-authorization";
export const workspace = {
  routes: [
    {
      path: "/workspace/library/risk-definition",
      component: () => import("../workspace-library-risk-definition-view"),
    },
    {
      path: "/workspace/library/risk-threat-definition",
      component: () => import("../workspace-library-risk-threat-definition-view"),
    },
    {
      path: "/workspace/library/risk-weakness-definition",
      component: () => import("../workspace-library-risk-weakness-definition-view"),
    },
    {
      path: "/workspace/library/risk-applied-control",
      component: () => import("../workspace-library-risk-applied-control-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/risk-definition",
      component: () => import("../management-library-risk-definition-view"),
    },
    {
      path: "/management/risk-threat-definition",
      component: () => import("../management-library-risk-threat-definition-view"),
    },
    {
      path: "/management/risk-weakness-definition",
      component: () => import("../management-library-risk-weakness-definition-view"),
    },
    {
      path: "/management/risk-applied-control",
      component: () => import("../management-library-risk-applied-control-view"),
    },
  ],
};

export const gdpr = {
  routes: [
    {
      path: "/gdpr/risk",
      component: () => import("../organization-risk-view"),
    },
    {
      path: "/gdpr/risk-detail/:id",
      component: () => import("../organization-risk-detail"),
    },
    {
      path: "/gdpr/risk/create",
      component: () => import("../organization-risk-detail"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/risk",
      component: () => import("../organization-risk-view"),
    },
    {
      path: "/kvkk/risk-detail/:id",
      component: () => import("../organization-risk-detail"),
    },
    {
      path: "/kvkk/risk/create",
      component: () => import("../organization-risk-detail"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/risk",
      component: () => import("../organization-risk-view"),
    },
    {
      path: "/ddo/risk-detail/:id",
      component: () => import("../organization-risk-detail"),
    },
    {
      path: "/ddo/risk/create",
      component: () => import("../organization-risk-detail"),
    },
  ],
};

export const bgys = {
  routes: [
    {
      path: "/bgys/risk",
      component: () => import("../organization-risk-view"),
    },
    {
      path: "/bgys/risk-detail/:id",
      component: () => import("../organization-risk-detail"),
    },
    {
      path: "/bgys/risk/create",
      component: () => import("../organization-risk-detail"),
    },
  ],
};

export const risk = {
  routes: [
    {
      path: "/risk/dashboard",
      component: () => import("../organization-risk-dashboard"),
      meta: { rules: [] },
    },
    {
      path: "/risk/decision",
      component: () => import("../organization-risk-decision-view"),
      meta: { rules: [] },
    },
    {
      path: "/risk/list",
      component: () => import("../organization-risk-list-view"),
      meta: { rules: [] },
    },

    {
      path: "/risk/corporate-risk",
      component: () => import("../corporate-risk-view"),
      meta: { rules: [] },
    },
    {
      path: "/risk/corporate-risk/detail/:id",
      component: () => import("../corporate-risk-detail"),
      meta: { rules: [] },
    },
    {
      path: "/risk/corporate-risk/create",
      component: () => import("../corporate-risk-detail"),
      meta: { rules: [] },
    },
  ],
};

export const organization = {
  routes: [
    {
      path: "/organization/risk",
      meta: { rules: [canGetRiskLayoutPages] }, // TKP-150
      component: () => import("../organization-risk-view"),
    },
    {
      path: "/organization/risk-detail/:id",
      meta: { rules: [canGetRiskLayoutPages] }, // TKP-150
      component: () => import("../organization-risk-detail"),
    },
    {
      path: "/organization/risk/create",
      meta: { rules: [canGetRiskLayoutPages] }, // TKP-150
      component: () => import("../organization-risk-detail"),
    },
  ],
};
